const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1' ||
    window.location.hostname === '::1',
)

export function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) {
    return
  }

  const shouldRegister = import.meta.env.PROD || import.meta.env.VITE_ENABLE_SW === 'true'

  if (!shouldRegister) {
    if (import.meta.hot && isLocalhost) {
      unregisterServiceWorker()
    }
    return
  }

  window.addEventListener('load', () => {
    const swUrl = '/sw.js'

    navigator.serviceWorker
      .register(swUrl)
      .then((registration) => {
        if (import.meta.env.DEV) {
          console.info('Service worker registered', registration.scope)
        }
      })
      .catch((error) => {
        console.error('Service worker registration failed', error)
      })
  })
}

export function unregisterServiceWorker() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister()
      })
      .catch(() => undefined)
  }
}

if (import.meta.hot && isLocalhost && import.meta.env.VITE_ENABLE_SW !== 'true') {
  unregisterServiceWorker()
}
